import './Divider.css'

function Divider() {
    return (
        <>
            <div className="divider">
                <span className="icon">
                    <img src="/svg/startup.svg" alt="startup svg" />
                </span>
            </div>
        </>
    )
}

export default Divider;